import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Divider,
} from '@mui/material';
import React from 'react';

import { theme } from '@app/theme';
import { Product } from '@app/types/catalog';

interface OrganizationInfoProps {
  product: Product;
}

const TableCellWithStyle = ({ children }: { children: React.ReactNode }) => (
  <TableCell
    sx={{
      backgroundColor: theme.palette.neutral.sky,
      fontWeight: 'bold',
      width: '30%',
    }}
  >
    {children}
  </TableCell>
);

export function OrganizationInfo({ product }: OrganizationInfoProps) {
  if (typeof product.organization === 'string') {
    return null;
  }

  return (
    <Box sx={{ p: 2 }}>
      <Divider sx={{ my: 4 }} />
      <Typography variant="h6" fontWeight={600} sx={{ mb: 3 }}>
        会社情報
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          border: `1px solid ${theme.palette.neutral.silver}`,
          borderRadius: '8px',
          width: '100%',
        }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCellWithStyle>取引形態</TableCellWithStyle>
              <TableCell>
                <Typography>
                  {product.customFields.conditionsTransaction}
                </Typography>
                <Typography>
                  {product.customFields.conditionsTransactionNote &&
                    product.customFields.conditionsTransactionNote}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCellWithStyle>住所</TableCellWithStyle>
              <TableCell>
                <Typography>{product.customFields.companyAddress}</Typography>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCellWithStyle>所属団体名</TableCellWithStyle>
              <TableCell>
                <Typography>{product.customFields.groupName} </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCellWithStyle>免許番号</TableCellWithStyle>
              <TableCell>
                <Typography>{product.customFields.licenseNumber}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCellWithStyle>会社名</TableCellWithStyle>
              <TableCell>{product.customFields.companyName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCellWithStyle>問い合わせ</TableCellWithStyle>
              <TableCell>
                <Typography>{product.customFields.contactAddress}</Typography>
                <Typography>
                  {product.customFields.contactPhoneNumber}
                </Typography>
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ color: theme.palette.grey[500] }}
                >
                  {product.customFields.contactAdditional}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
